<template>
  <div class="page_bd Contact-area">
    <secBanner></secBanner>
    <div class="breadcrumb-nav">
      <div class="container">
        您现在的位置：
        <router-link to="/">首页</router-link>
        >
        <router-link :to="{ path: '/contactus', query: { tab: 0 } }"
          >联系我们</router-link
        >
        >
        <span v-if="activeIndex > -1">{{
          activeIndex == 0 ? "联系方式" : "在线留言"
        }}</span>
      </div>
    </div>
    <div class="container content-area">
      <div class="tabs">
        <div
          class="tab"
          :class="{ active: activeIndex == '0' }"
          @click="activeIndex = 0"
        >
          联系方式
        </div>
        <div
          class="tab"
          :class="{ active: activeIndex == '1' }"
          @click="activeIndex = 1"
        >
          在线留言
        </div>
        <!-- <router-link
          class="tab"
          :class="{ active: activeIndex == '0' }"
          :to="{ path: '/contactus', query: { tab: 0 } }"
          >联系方式</router-link
        >
        <router-link
          class="tab"
          :class="{ active: activeIndex == '1' }"
          :to="{ path: '/contactus', query: { tab: 1 } }"
          >在线留言</router-link
        > -->
      </div>
      <div class="lead">{{ activeIndex == 0 ? "联系方式" : "在线留言" }}</div>
      <div class="panels">
        <div class="panel" v-if="activeIndex == 0">
          <ul class="modes dis_flex dis_jucontween">
            <li>
              <div class="img"><img src="@/assets/06.png" alt="" /></div>
              <div class="info">
                <p>联系电话</p>
                <p>{{ config.mobile }}</p>
              </div>
            </li>
            <li>
              <div class="img"><img src="@/assets/07.png" alt="" /></div>
              <div class="info">
                <p>传真</p>
                <p>{{ config.qq }}</p>
              </div>
            </li>
            <li>
              <div class="img"><img src="@/assets/08.png" alt="" /></div>
              <div class="info">
                <p>邮箱</p>
                <p>{{ config.email }}</p>
              </div>
            </li>
          </ul>
          <!-- 'http://zxsd.wanjiejixie.com/uploads/index/20200810/9748f8960e515d1cc825f8f95119e2b2.png' -->
          <baidu-map
            class="bm-view"
            ak="BOqLbj5By5RdVMdTdwyL88Cw"
            :center="center"
            :zoom="15"
          >
            <bm-marker
              :position="center"
              :icon="{
                url: require('@/assets/map2.png'),
                size: { width: 40, height: 40 }
              }"
            ></bm-marker>
          </baidu-map>
        </div>
        <div class="panel" v-if="activeIndex == 1">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="98px"
            class="formarea"
            label-position="right"
          >
            <el-form-item label="留言内容：" prop="message">
              <el-input
                type="textarea"
                v-model="ruleForm.message"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 6, maxRows: 6 }"
                placeholder="小于等于500字符"
              ></el-input>
            </el-form-item>
            <el-form-item label="您的姓名：" prop="name">
              <el-input
                v-model="ruleForm.name"
                placeholder="小于等于20个字符（包括A-Z、a-z、0-9、汉字、不含特殊字符）"
              ></el-input>
            </el-form-item>
            <el-form-item label="您的邮箱：" prop="email"
              ><el-input
                v-model="ruleForm.email"
                placeholder="示例：example@mail.com"
              ></el-input
            ></el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input
                v-model.number="ruleForm.phone"
                placeholder="由数字、“+”、中横杠“-”组成，最大允许20个字符"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系地址：" prop="address"
              ><el-input v-model.number="ruleForm.address"></el-input
            ></el-form-item>
            <div class="dis_flex dis_jucontween">
              <el-form-item label="验 证 码：" prop="captcha" style="flex: 1;"
                ><el-input v-model="ruleForm.captcha"></el-input
              ></el-form-item>
              <div class="code-img dis_flex dis_ali" @click="refreshCode">
                <!-- <img :src="codeImgSrc" height="30px" alt="验 证 码" /> -->
                <s-identify :identifyCode="identifyCode"></s-identify>
                看不清楚？换张图片
              </div>
            </div>

            <el-form-item>
              <div class="submit-btn" @click="submitForm('ruleForm')">提交</div>
              <div class="reset-btn" @click="resetForm('ruleForm')">重填</div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import secBanner from "@/components/assembly/sec-banner";
import SIdentify from "./assembly/sIdentify";
import {
  BaiduMap,
  BmControl,
  BmView,
  BmAutoComplete,
  BmLocalSearch,
  BmMarker
} from "vue-baidu-map";
export default {
  data() {
    var codePass = (rule, value, callback) => {
      // console.log(value)
      if (!value) {
        return callback(new Error("验证码为必填项，请填写"));
      }
      if (value != this.identifyCode) {
        return callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    return {
      config: "",
      ruleForm: {
        name: "",
        email: "",
        phone: "",
        captcha: "",
        message: "",
        provice: "河南省",
        city: "郑州市"
      },
      rules: {
        name: [
          {
            required: true,
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur"
          }
        ],
        message: [
          // /^\s*$/.test(C.content.value)
          {
            required: true,
            message: "留言内容为必填项，请填写",
            trigger: "blur"
          }
        ],
        captcha: [{ validator: codePass, trigger: "blur", required: true }]
      },
      codeImgSrc: "",
      identifyCode: "",
      identifyCodes: "0123456789",
      activeIndex: this.$route.query.tab,
      center: { lng: 113.51292, lat: 34.842012 }
    };
  },
  mounted() {
    this.makeCode(this.identifyCodes, 4);
    this.$https.fetchPost("/index/get_config", {}).then(response => {
      this.config = response.data;
    });
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitformData();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitformData: function() {
      var _this = this;
      this.$https
        .fetchPost("/formdata/customer", this.ruleForm)
        .then(res => {
          // console.log(res.data)
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: "success"
            });
            setTimeout(() => {
              _this.$refs["ruleForm"].resetFields();
              _this.refreshCode();
            }, 3000);
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
            setTimeout(() => {
              _this.refreshCode();
            }, 3000);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeImgCode() {
      // var num = Math.ceil(Math.random() * 10) // 生成一个随机数（防止缓存）
      // this.codeImgSrc = this.$requesturl + 'api/yzm?' + num
    },
    refreshCode() {
      //
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    randomNum(min, max) {
      max = max + 1;
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 随机生成验证码字符串
    makeCode(data, len) {
      for (let i = 0; i < len; i++) {
        this.identifyCode += data[this.randomNum(0, data.length - 1)];
      }
    }
  },
  components: {
    secBanner,
    SIdentify,
    BaiduMap,
    BmControl,
    BmView,
    BmAutoComplete,
    BmLocalSearch,
    BmMarker
  },
  watch: {
    $route(to, from) {
      // data数据操作
      if (to.query.tab != from.query.tab) {
        this.activeIndex = this.$route.query.tab;
      }
    }
  }
};
</script>
<style lang="less">
.Contact-area {
  .tabs {
    width: 320px;
    .tab {
      width: 50%;
    }
  }
  .bm-view {
    margin-top: 60px;
    width: 100%;
    height: 400px;
  }
  .modes {
    li {
      display: flex;
      align-items: center;
      p {
        font-family: MicrosoftYaHei;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 0px;
        color: rgba(51, 51, 51, 1);
      }
      .info {
        flex: 1;
      }
      .img {
        width: 60px;
        height: 60px;
        margin-right: 15px;
      }
    }
  }
  .el-input__inner,
  .el-textarea__inner,
  .el-input__count {
    background-color: rgba(241, 241, 241, 1);
  }
  .code-img {
    margin-bottom: 22px;
    margin-left: 15px;
    font-family: MicrosoftYaHei;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0.7px;
    color: #666666;
    cursor: pointer;
    .s-canvas {
      margin-right: 10px;
    }
  }
  .submit-btn {
    display: inline-block;
    width: 147px;
    background-color: rgba(31, 113, 194, 1);
    font-family: MicrosoftYaHei;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: rgba(255, 255, 255, 1);
    line-height: 43px;
    letter-spacing: 0.8px;
    color: #ffffff;
    text-align: center;
    margin: 20px 20px 0 0;
    cursor: pointer;
    border-radius: 5px;
  }
  .reset-btn {
    display: inline-block;
    width: 147px;
    height: 43px;
    background-color: rgba(240, 240, 240, 1);
    font-family: MicrosoftYaHei;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: rgba(51, 51, 51, 1);
    line-height: 43px;
    letter-spacing: 0.8px;
    text-align: center;
    cursor: pointer;
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contactus.vue